
export const truncateText = (text = "", maxLength = 10) =>
    text && text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
